module.exports = __webpack_public_path__ + "img/bottom.df496e9d.png";